import Icon from '../components/Icon.vue'

Icon.register({"lightbulb":{"width":384,"height":512,"paths":[{"d":"M272 428V456C272 466.4 265.3 475.3 256 478.6V488C256 501.3 245.3 512 232 512H152C138.7 512 128 501.3 128 488V478.6C118.7 475.3 112 466.4 112 456V428C112 421.4 117.4 416 124 416H260C266.6 416 272 421.4 272 428zM128.9 384C119 384 110.1 377.9 106.5 368.7 67.7 267.5 16 277.7 16 176 16 78.8 94.8 0 192 0S368 78.8 368 176C368 277.7 316.3 267.5 277.5 368.7 273.9 377.9 265 384 255.1 384H128.9zM112 176C112 131.9 147.9 96 192 96 200.8 96 208 88.8 208 80S200.8 64 192 64C130.2 64 80 114.2 80 176 80 184.8 87.2 192 96 192S112 184.8 112 176z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/lightbulb.js
// module id = null
// module chunks = 